<template>
   <div>
    <div class="home-organize-slider">
        <div class="swiper-container" ref="swiperContainer">
            <!-- <h2 class="slider-title">Whatever you do, you can do it in Infinity</h2> -->
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <span class="slide-title" style="color: rgb(218, 74, 190); background-color: rgba(218, 74, 190, 0.1)">Product Roadmap</span>
                    <div class="swiper-image">
                        <img class="img-fluid" src="img/slider-product-roadmap.png" alt>
                    </div>
                </div>
                <div class="swiper-slide">
                    <span class="slide-title" style="color: rgb(78, 180, 249); background-color: rgba(78, 180, 249, 0.1)">Content Calendar</span>
                    <div class="swiper-image">
                        <img class="img-fluid" src="img/slider-content-calendar.png" alt>
                    </div>
                </div>
                <div class="swiper-slide">
                    <span class="slide-title" style="background: rgba(255, 160, 56, 0.1); color: rgb(255, 160, 56);">Project Management</span>
                    <div class="swiper-image">
                        <img class="img-fluid" src="img/slider-project-management.png" alt>
                    </div>
                </div>
                <div class="swiper-slide">
                    <span class="slide-title" style="color: rgb(42, 162, 117); background-color: rgba(42, 162, 117, 0.1)">Sales Pipeline</span>
                    <div class="swiper-image">
                        <img class="img-fluid" src="img/slider-sales-pipeline-crm.png" alt>
                    </div>
                </div>
                <div class="swiper-slide">
                    <span class="slide-title" style="color: rgb(158, 127, 246); background-color: rgba(158, 127, 246, 0.1)">Agile Sprints</span>
                    <div class="swiper-image">
                        <img class="img-fluid" src="img/slider-agile-sprints.png" alt>
                    </div>
                </div>
                <div class="swiper-slide">
                    <span class="slide-title" style="color: rgb(250, 96, 126); background-color: rgba(250, 96, 126, 0.1)">Marketing Campaigns</span>
                    <div class="swiper-image">
                        <img class="img-fluid" src="img/slider-marketing-campaigns.png" alt>
                    </div>
                </div>
                <div class="swiper-slide">
                    <span class="slide-title" style="color: rgb(1, 67, 147); background-color: rgba(1, 67, 147, 0.1)">Meeting Calendar</span>
                    <div class="swiper-image">
                        <img class="img-fluid" src="img/pre-ltd/meeting-calendar.png" alt>
                    </div>
                </div>
            </div>
            <div class="arrows container">
                <div class="swiper-button-next">
                    <span class="ic-arrow-right"></span>
                </div>
                <div class="swiper-button-prev">
                    <span class="ic-arrow-left"></span>
                </div>
            </div>
        </div>
        <!-- <div class="swiper-pagination organize"></div> -->
    </div>
    <!-- <div class="organize-scroll">
        <h2 class="slider-title">Whatever you do, you can do it in Infinity</h2>
     <div style="overflow: auto hidden;display:flex;">
        <div class="scroll-single">
            <span class="slide-title">Product Roadmap</span>
            <div class="scroll-image">
                <img class="img-fluid" style="height: 360px; width: auto;" src="img/slide-product-roadmap.png" alt>
            </div>

        </div>
        <div class="scroll-single">
            <span class="slide-title">Content Calendar</span>
            <div class="scroll-image">
                <img class="img-fluid" style="height: 360px; width: auto;" src="img/slide-content-calendar.png" alt>
            </div>
        </div>
         <div class="scroll-single">
            <span class="slide-title">Project Management</span>
            <div class="scroll-image">
                <img class="img-fluid" style="height: 360px; width: auto;"  src="img/slide-project-management.png" alt>
            </div>
        </div>
         <div class="scroll-single">
            <span class="slide-title">Sales Pipeline</span>
            <div class="scroll-image">
                <img class="img-fluid" style="height: 360px; width: auto;" src="img/slide-sales-pipeline-crm.png" alt>
            </div>
        </div>
         <div class="scroll-single">
            <span class="slide-title">Agile Sprints</span>
            <div class="scroll-image">
                <img class="img-fluid" style="height: 360px; width: auto;" src="img/slide-agile-sprints.png" alt>
            </div>
        </div>
        <div class="scroll-single">
            <span class="slide-title">Marketing Campaigns</span>
            <div class="scroll-image">
                <img class="img-fluid" style="height: 360px; width: auto;" src="img/slide-marketing-campaigns.png" alt>
            </div>
        </div>
     </div>
    </div> -->
    </div>
</template>
<style scoped>
@media(min-width:990px){
    .home-organize-slider{
        display:block;
    }
    .organize-scroll {
        display:none;
    }
    .swiper-slide {
        width: 60%;
    }
}
@media(max-width:990px){
    .swiper-slide {
        width: 100%;
    }
    .arrows {
        display: none;
    }
}
/* .swiper-container {
        margin-top: 90px; 
} */
.swiper-slide {
    flex-direction: column;
    text-align: center;
    font-size: 18px;
    background: transparent !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
.organize-scroll{
    position:relative;
    width: 100%;
    overflow: auto;
    margin-top:40px;
}
.scroll-single{
    flex:none;
    margin-left: 40px;
}
.scroll-single .slide-title{
    display: flex;
    justify-content: center;
}
.swiper-image {
    opacity: 0.4;
    transition: opacity 0.3s;
}
.swiper-slide-active .swiper-image {
    opacity: 1;
    border-radius: 17.14px;
}
.slider-title {
    color: #1f2243;
    font-size: 36px;
    line-height: 48px;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 1px;
    font-family: "Avenir Next Medium"
}
.slide-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    padding: 10px;
    margin-bottom: 10px;
}
</style>
<style>
.swiper-pagination.organize{
    margin: 0 auto;
    text-align: center;
    position: relative;
}
.organize .swiper-pagination-bullet:active,
.organize .swiper-pagination-bullet-active:focus {
    outline:0;
}
.organize .swiper-pagination-bullet-active {
    background: #926dff;
}
.organize .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    margin-right:10px;
}
.swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 10px;
}
.swiper-button-prev {
    background-image: none;
    color: #8f90a1;
    font-size: 40px;
    position: absolute;
    right: 10px;
}
.swiper-button-prev:active {
    outline: none;
}
.swiper-button-prev:focus {
    outline: none;
}
.swiper-button-next {
    background-image: none;
    color: #8f90a1;
    font-size: 40px;
    position: absolute;
    right: 10px;
}
.swiper-button-next:focus {
    outline: none;
}
.swiper-button-next:active {
    outline: none;
}
</style>
<script>
import Swiper from 'swiper';
export default {
    data() {
        return {
            swiper: null,
        };
    },
    destroyed() {
        this.swiper.destroy();
        this.swiper = null;
    },
    mounted() {
        this.swiper = new Swiper(this.$refs.swiperContainer, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            loop: true,

            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/OrganizeSlider.vue